module.exports = "<h1></h1>\r\n<div class=\"row\">\r\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span class=\"group-value\">Board</span></div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-4 col-sm-6 col-xs-12\" *ngFor=\"let device of deviceList\">\r\n            <device-info [deviceModel]=\"device\"></device-info>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/devices/devices.component.html
// module id = ./src/app/components/devices/devices.component.html
// module chunks = main